import { dispatcher } from 'react-structure-admin';

export const INBOUND_INVOICE = 'INBOUND_INVOICE';
export const INBOUND_INVOICE_REFRESH = 'INBOUND_INVOICE_REFRESH';

export const refresh = () => (dispatch) => {
  dispatch(dispatcher.createAction(INBOUND_INVOICE_REFRESH, 'inbound-invoices'));
};
